import Navbar from '../components/Navbar/Navbar';
import AboutBanner from '../sections/AboutBanner/AboutUsPage';
import Footer from '../sections/Footer/Footer';

const About = () => {
    return (
        <>
            <Navbar />
            <AboutBanner />
            <Footer />
        </>
    );
};

export default About;